import React from "react";
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import EditRegistration from "./EditRegistration.js";
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import DateHelpers from "../Helper/DateHelpers.js";
import { useState, useEffect } from "react";
import '../Styles/RegistrationCard.scss';
import EditRegistrationForm from "./EditRegistrationForm.js";

function RegistrationCard({ queriedRegistration }) {

   const [viewRegistrationDetails, setViewRegistrationDetails] = useState(false)
   console.log("Queried Registration", queriedRegistration)
   return (
      <div className="RegistrationCardContainer">
         <div className="RegistrationCardContent">
            <div className="RegistrationCardInformation">
               <div className="RegistrationCardLeftSideInfo">
                  <div className="RegistrationCardEventName">
                     {queriedRegistration.event_camp_name}
                  </div>
                  <div className="RegistrationCardDates">
                     {DateHelpers.getEventDateRange(queriedRegistration.event_begin_date, queriedRegistration.event_end_date)}
                  </div>
                  <div className="RegistrationCardCamperName">
                     {queriedRegistration.registration_first_name + " " + queriedRegistration.registration_last_name}
                  </div>
               </div>
               <div className="RegistrationCardRightSideInfo">
                  <div className="RegistrationCardAmountDue">
                     Amount Due: ${queriedRegistration.registration_amount_due}
                  </div>
                  {/* Payment moved to the single "Make a Payment" panel below the list, so one card
                      entry can cover every registration with a balance instead of one per card. */}
                  {queriedRegistration.registration_has_paid === true &&
                     <div className="RegistrationCardPaidInFullText">
                        Paid in Full
                     </div>
                  }
                  <div className="RegistrationCardViewDetailsButton">
                     <button onClick={() => setViewRegistrationDetails(!viewRegistrationDetails)}>
                        View Details
                     </button>
                  </div>
               </div>
            </div>
            {viewRegistrationDetails === true &&
               <div className="EditRegistrationForm">
                  <EditRegistrationForm
                     queriedRegistration={queriedRegistration} />
               </div>
            }
         </div>
      </div>
   )
}
export default RegistrationCard;